import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { api, fmtDate, fmtClock } from "../../lib/api";
import { usePoll } from "../../lib/usePoll";
import { useAuth } from "../../lib/auth";
import { PageHeader, StatusBadge, Loading, inputCls } from "../../components/common";

export default function Meetings() {
  const { user } = useAuth();
  const [arch, setArch] = useState(false);
  const [q, setQ] = useState("");
  const [st, setSt] = useState("");
  const { data } = usePoll(() => api.get(`/meetings?include_archived=${arch}`).then((r) => r.data), 15000, [arch]);
  const list = (data || []).filter((m) => (!q || `${m.title} ${m.code} ${m.organizer}`.toLowerCase().includes(q.toLowerCase())) && (!st || m.status === st));
  return (
    <div>
      <PageHeader title="Manage Meetings" sub="Open, pause, close and finalize registration from each meeting's control panel.">
        {user.role === "admin" && <Link to="/admin/meetings/new" className="btn-sm btn-primary" data-testid="meetings-create-btn"><Plus className="h-4 w-4" />Create Meeting</Link>}
      </PageHeader>
      <div className="flex flex-wrap gap-2 mb-4">
        <input className={`${inputCls} h-10 max-w-xs`} placeholder="Search meetings" value={q} onChange={(e) => setQ(e.target.value)} data-testid="meetings-search" />
        <select className={`${inputCls} h-10 w-auto`} value={st} onChange={(e) => setSt(e.target.value)} data-testid="meetings-status-filter">
          <option value="">All statuses</option>{["scheduled", "open", "paused", "closed", "finalized"].map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={arch} onChange={(e) => setArch(e.target.checked)} data-testid="meetings-show-archived" />Show archived</label>
      </div>
      {!data ? <Loading /> : (
        <div className="sfap-card overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left text-[11px] uppercase tracking-wider text-stone-500 bg-[#FBF8F2]"><tr>{["Meeting", "Category", "Date & time", "Venue", "Verified", "Pending", "Status"].map((h) => <th key={h} className="px-4 py-3">{h}</th>)}</tr></thead>
            <tbody>
              {list.map((m) => (
                <tr key={m.id} className={`border-t border-[#F0EADC] hover:bg-[#FBF8F2] ${m.archived ? "opacity-50" : ""}`}>
                  <td className="px-4 py-3"><Link to={`/admin/meetings/${m.id}`} className="font-semibold text-[#2D3B2D] hover:underline" data-testid={`meeting-link-${m.code}`}>{m.title}</Link><div className="text-xs font-mono text-stone-500">{m.code}</div></td>
                  <td className="px-4 py-3 text-stone-600">{m.category_name}</td>
                  <td className="px-4 py-3 whitespace-nowrap">{fmtDate(m.date)}<div className="text-xs text-stone-500">{fmtClock(m.start_time)}{m.sessions?.length > 1 ? ` · ${m.sessions.length} sessions` : ""}</div></td>
                  <td className="px-4 py-3">{m.venue}</td>
                  <td className="px-4 py-3 font-bold tabular-nums">{m.verified_count}</td>
                  <td className="px-4 py-3 tabular-nums">{m.pending_count}</td>
                  <td className="px-4 py-3"><StatusBadge status={m.status} /></td>
                </tr>
              ))}
              {!list.length && <tr><td colSpan={7} className="px-4 py-12 text-center text-stone-400">No meetings yet</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
